const tests = [
    {
        'uuid': '1',
        'customerName': '中農粉絲有限公司',
        'productName': '杏仁玄米餅',
        'testType': 'finishedGood',
        'testName': '杏仁玄米餅',
        'manufacturer': '大甲製造',
        "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
        'testResult': 'qualified',
    },
    {
        'uuid': '2',
        'customerName': '源天然股份有限公司',
        'productName': 'Pasta義大利麵',
        'testType': 'finishedGood',
        'testName': 'Pasta義大利麵',
        'manufacturer': '穎昌食品有限公司(新和美)',
        "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
        'testResult': 'qualifiedDetected',
    },
    {
        'uuid': '3',
        'customerName': '豆之家食品有限公司',
        'productName': '桂圓四物飲',
        'testType': 'finishedGood',
        'testName': '桂圓四物飲',
        'manufacturer': '青田農產有限公司',
        "testItems":[{testItem:"09", details:["0901", "0903"]},{testItem:"10", details:["1002","1004"]}],
        'testResult': 'unqualified',
    },
]

export default tests;